import TaxiCorporationUnbilledRouteListRequest, {
  TaxiCorporationUnbilledRouteListQueryParams,
} from "./taxi-corporation-unbilled-route-list.request";

const create = (
  request: TaxiCorporationUnbilledRouteListRequest,
): TaxiCorporationUnbilledRouteListQueryParams => {
  return {
    address: request.address,
    cargoOrderHumanId: request.cargoOrderHumanId,
    client: request.client,
    driver: request.driver,
    endAddress: request.endAddress,
    externalId: request.externalId,
    fleetPartner: request.fleetPartner,
    humanId: request.humanId,
    limit: request.limit,
    midAddress: request.midAddress,
    offset: request.offset,
    order: request.order,
    startAddress: request.startAddress,
    startTimeSince: request.startTimeSince,
    startTimeTo: request.startTimeTo,
  };
};

const taxiCorporationUnbilledRouteListRequestFactory = {
  create,
};

export default taxiCorporationUnbilledRouteListRequestFactory;
